import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {FormikHelpers} from 'formik';

import {Form, Button, Modal} from '@components';
import {Props} from './types';
import paths from '@paths';
import constants from '@constants';
import utils from '@utils';
import mappings from '@mappings';
import resources from '@resources';
import * as handlers from './handlers';

import './index.scss';

const Edit: React.FC<Props> = props => {
  const [isModal, setIsModal] = useState(false);

  const initialValues = {
    lastName: props.me.lastName,
    firstName: props.me.firstName,
    lastKana: props.me.lastKana,
    firstKana: props.me.firstKana,
    email: props.me.email,
    phoneNumber: props.me.phoneNumber,
    prefecture: props.me.prefecture,
    authLevel: props.me.authLevel,
    position: props.me.position,
    organization: props.me.organization,
    gender: props.me.gender,
    plan: utils.mappings.getLabel(mappings.plan, props.me.plan),
    birthyear: resources.users.getBirthValue('year', props.me.birthdate),
    birthmonth: resources.users.getBirthValue('month', props.me.birthdate),
    birthday: resources.users.getBirthValue('day', props.me.birthdate),
  };

  return (
    <div className="a__mypage-edit">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        プロフィール変更
      </div>
      <div className="b__main">
        <div className="w__create-field">
          <div className="w__information-field">
            <div className="w__form">
              <Form.User
                submitText="変更を保存する"
                me={props.me}
                users={props.users}
                initialValues={initialValues}
                handleSubmit={(
                  value: any,
                  formikHelpers: FormikHelpers<any>
                ) => {
                  handlers.submit(
                    value,
                    formikHelpers,
                    props.actions,
                    props.me,
                    props
                  );
                }}
                isOption
                changePassword
                setIsModal={() => setIsModal(true)}
                myPage
              />
            </div>
          </div>
          <div className="w__side-buttons">
            {props.me.authLevel === constants.AUTHORITIES.SUPER_ADMIN && (
              <div className="w__link">
                <Link to={paths.myPage.leave}>AnpiCheckerから退会する</Link>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal.ChangePassword
        title="パスワードリセット"
        isModal={isModal}
        handleCloseModal={() => setIsModal(false)}
      />
    </div>
  );
};

export default Edit;
